'use client';

import { Box, VStack, Text, HStack, Image } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useQRCode } from 'next-qrcode';

const APP_DOWNLOAD_URL = 'https://app.wildmeta.ai/en-US/app-download'

interface DownloadMobileAppCardProps {
  traderName: string;
}

export function DownloadMobileAppCard({
  traderName = 'James Wynn',
}: DownloadMobileAppCardProps) {
  const { Canvas } = useQRCode();
  const [inviteCode, setInviteCode] = useState<string>('');
  
  useEffect(() => {
    // Extract invite code from URL search params
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('inviteCode');
    if (code) {
      setInviteCode(code);
    }
  }, []);
  
  return (
    <Box
      w="full"
      display={{ base: 'none', md: 'block'}}
      p={6}
      border="1px solid"
      borderColor="rgba(255, 255, 255, 0.1)"
      borderRadius="16px"
      background="linear-gradient(164.527deg, rgba(66, 216, 192, 0.2) 2.64%, rgba(66, 216, 192, 0) 23.28%, rgba(66, 216, 192, 0) 74.28%, rgba(66, 216, 192, 0.2) 99.16%), linear-gradient(90deg, rgb(23, 26, 28) 0%, rgb(23, 26, 28) 100%)"
    >
      <VStack align="flex-start" gap={4}>
        {/* Title */}
        <Box>
          <Text
            fontSize="20px"
            fontWeight="bold"
            lineHeight="1.2"
            background="linear-gradient(270deg, #50D2C1 0%, #C2F3F7 100.99%)"
            bgClip="text"
            whiteSpace="nowrap"
          >
            Download Mobile App
          </Text>
        </Box>

        {/* Description */}
        <Text
          fontSize="14px"
          fontWeight="medium"
          color="white"
          lineHeight="normal"
        >
          Download the app to get real-time opening alerts and complete trading history for <Text as="span" fontWeight="bold">{traderName}</Text>.
        </Text>

        {/* QR Code Section */}
        <Box
          w="full"
          p={3}
          bg="rgba(123, 231, 231, 0.09)"
          borderRadius="8px"
        >
          <HStack gap={4} align="center">
            {/* QR Code Image */}
            <Box
              flexShrink={0}
              w="70.117px"
              h="70.117px"
              borderRadius="4px"
              overflow="hidden"
            >
              {/* <Image
                src="/images/download/qrcode.png"
                alt="Download QR Code"
                w="full"
                h="full"
                objectFit="cover"
              /> */}
              <Canvas
                text={`${APP_DOWNLOAD_URL}${inviteCode ? `?inviteCode=${inviteCode}` : ''}`}
                options={{
                  width: 70,
                  type: 'image/png',
                  margin: 0,
                  scale: 4,
                  color: {
                    dark: '#FFFFFF',
                    light: '#000000',
                  },
                }}
              />
            </Box>

            {/* Download Info */}
            <VStack align="flex-start" gap={1} flex={1}>
              <Text
                fontSize="12px"
                fontWeight="semibold"
                color="rgba(255, 255, 255, 0.6)"
                textTransform="uppercase"
                lineHeight="normal"
              >
                Scan to download
              </Text>
              <Text
                fontSize="18px"
                fontWeight="semibold"
                color="white"
                lineHeight="1.2"
                whiteSpace="nowrap"
              >
                iOS & Android
              </Text>
            </VStack>
          </HStack>
        </Box>
      </VStack>
    </Box>
  );
}
